import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */

/* Original name @uswitch/trustyle.link-list */
import * as React from 'react';
import { Themed } from 'theme-ui';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { Link } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var VariantContext = /*#__PURE__*/React.createContext('base');

var styles = function styles(variant, element) {
  return "elements.link-list.variants.".concat(variant).concat(element ? ".".concat(element) : '');
};

export var LinkListTrustyle = function LinkListTrustyle(_ref) {
  var children = _ref.children,
      title = _ref.title,
      icon = _ref.icon,
      subtitle = _ref.subtitle,
      subtitleUrl = _ref.subtitleUrl,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant,
      className = _ref.className;
  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  var IconComponent = typeof icon === 'string' ? _jsx(DynamicSparkIcon, {
    glyph: icon,
    color: ""
  }) : icon;
  var titleProps = {
    as: 'h2',
    sx: {
      paddingTop: 'xs',
      paddingBottom: 'xs',
      margin: 0,
      variant: styles(variant, 'h3')
    }
  };
  return _jsx(VariantContext.Provider, {
    value: variant,
    children: _jsxs("div", {
      className: className,
      sx: {
        variant: styles(variant)
      },
      children: [title || icon ? _jsxs("section", {
        children: [_jsxs("header", {
          sx: {
            display: 'flex',
            alignItems: 'center',
            variant: styles(variant, 'header')
          },
          children: [variant === 'linkBlock' ? _jsx("div", {
            sx: {
              variant: styles(variant, 'icon')
            },
            children: IconComponent
          }) : null, variant !== 'linkBlock' ? IconComponent : null, title ? _jsxs(React.Fragment, {
            children: [variant === 'linkBlock' ? _jsx(Themed.h6, _objectSpread(_objectSpread({}, titleProps), {}, {
              children: title
            })) : null, variant !== 'linkBlock' ? _jsx(Themed.h3, _objectSpread(_objectSpread({}, titleProps), {}, {
              children: title
            })) : null]
          }) : null]
        }), subtitle && subtitleUrl ? _jsx(LinkListTrustyleItem, {
          href: subtitleUrl,
          children: _jsx("strong", {
            style: {
              backgroundColor: 'unset'
            },
            children: subtitle
          })
        }) : null]
      }) : null, _jsx("ul", {
        sx: {
          padding: 0,
          listStyle: 'none',
          marginTop: '0'
        },
        children: children
      })]
    })
  });
};
export var LinkListTrustyleItem = function LinkListTrustyleItem(_ref2) {
  var children = _ref2.children,
      href = _ref2.href,
      className = _ref2.className,
      icon = _ref2.icon;
  // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  var IconComponent = typeof icon === 'string' ? _jsx(DynamicSparkIcon, {
    glyph: icon,
    color: ""
  }) : icon;
  var variant = React.useContext(VariantContext);
  return _jsxs("li", {
    sx: {
      borderTop: '1px solid',
      borderTopColor: 'grey-20',
      paddingTop: 'xs',
      paddingBottom: 'xs',
      marginBottom: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      variant: styles(variant, 'li')
    },
    className: className,
    children: [_jsx(Link, {
      href: href,
      sx: {
        textDecoration: 'none',
        borderBottom: 0,
        ':hover': {
          textDecoration: 'underline'
        }
      },
      children: children
    }), IconComponent]
  });
};
//# sourceMappingURL=index.js.map